import { render, staticRenderFns } from "./DrawerPs.vue?vue&type=template&id=105097a0&scoped=true&"
import script from "./DrawerPs.vue?vue&type=script&lang=js&"
export * from "./DrawerPs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105097a0",
  null
  
)

export default component.exports